<template>
  <Multiselect
    class="MultiSelectInput"
    v-bind="$props"
    :value="modelValue"
    @input="handleInput"
    @tag="addTag"
    :max="maxLength"
    :placeholder="placeholder"
    :isError="isError"
    :isErrorTag="isErrorTag"
    :allowSpaceAsEnter="allowSpaceAsEnter"
    :allowMoreMax="allowMoreMax"
    :hideList="hideList"
    :hint="hint"
    @load-more="$emit('load-more')"
    @search-change="$emit('search-change', $event)"
  />
</template>

<script type="text/babel">
import { Options, Vue } from "vue-class-component";
import Multiselect from "./multiselect";

@Options({
  components: { Multiselect },

  props: {
    modelValue: {},
    placeholder: {
      default: ""
    },
    options: {},
    label: {
      default: "name"
    },
    closeOnSelect: {
      default: false
    },
    selectLabel: {
      default: ""
    },
    trackBy: {
      default: "id"
    },
    multiple: {
      default: true
    },
    taggable: {
      default: false
    },
    hideSelected: {
      default: true
    },
    maxLength: {
      default: 0
    },
    isTextArea: {
      default: false
    },
    isError: {
      default: false
    },
    isErrorTag: {
      default: false
    },
    allowSpaceAsEnter: {
      type: Boolean,
      default: false
    },
    autoDeduplicate: {
      type: Boolean,
      default: false
    },
    keepFocusAfterCommit: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    showEndOfList: {
      type: Boolean,
      default: false
    },
    endOfListText: {
      type: String,
      default: ""
    },
    inputTestId: {
      type: String,
      default: ""
    },
    optionsTestId: {
      type: String,
      default: ""
    },
    optionsLoadingTestId: {
      type: String,
      default: ""
    },
    optionsEndTestId: {
      type: String,
      default: ""
    }
    // You may need to add more inputs here - this above is just my preferred default config
  },

  emits: [
    "update:modelValue",
    "duplicates-removed",
    "load-more",
    "search-change"
  ] // add more events here as needed. Make sure to propagate them in your template
})
export default class MultiSelect extends Vue {
  props = this.$props;
  handleInput(values) {
    if (!this.props.autoDeduplicate) {
      this.$emit("update:modelValue", values);
      return;
    }

    const uniqueValues = [];
    const existingStt = new Set();
    let duplicateCount = 0;

    values.forEach(item => {
      const sttNumber = String(item.name || "")
        .trim()
        .toUpperCase();

      if (existingStt.has(sttNumber)) {
        duplicateCount++;
        return;
      }

      existingStt.add(sttNumber);
      uniqueValues.push(item);
    });

    this.$emit("update:modelValue", uniqueValues);
    this.$emit("duplicates-removed", duplicateCount);
  }

  addTag(newTag) {
    const tag = {
      name: newTag,
      id: newTag,
      isError: false
    };

    if (this.props.autoDeduplicate) {
      this.handleInput([...this.props.modelValue, tag]);
      return;
    }

    this.props.options.push(tag);
    this.props.modelValue.push(tag);
  }
}
</script>
